<template>
  <div class="member-container">
    <img src="../../assets/img/DA6E6E8E-8C90-4A35-A8DF-42C4FF236395.png" />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>


<style lang="less" scoped>
.member-container {
  img {
    width: 100vw;
    height: auto;
  }
}
</style>